import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowBigRight } from 'lucide-react';
import { checkInviteToken } from '../../apiServices/invite/invite';
import ButtonAdd2 from '../../components/auth/ButtonAdd2';

function InvitePage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const validate = async () => {
      try {
        const response = await checkInviteToken({ token });
        if (response?.data?.valid) {
          sessionStorage.setItem('inviteToken', token);
          if (localStorage.getItem('accessToken')) {
            navigate(-1);
          } else {
            navigate('/login');
          }
        } else {
          sessionStorage.removeItem('inviteToken');
          setError(t('invitePage.invalidOrExpired'));
        }
      } catch {
        sessionStorage.removeItem('inviteToken');
        setError(t('invitePage.invalidOrExpired'));
      }
    };
    validate();
  }, [token]);

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '12px',
      color: 'var(--main1)',
    }}
    >
      {error ? (
        <>
          <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--visible)' }}>{error}</span>
          <ButtonAdd2
            onClick={() => navigate('/login')}
            text={t('invitePage.leave')}
            Icon={ArrowBigRight}
          />
        </>
      ) : (
        <span style={{ fontSize: '1rem', color: 'var(--visible)' }}>{t('invitePage.validating')}</span>
      )}
    </div>
  );
}

export default InvitePage;
